export default __webpack_public_path__ + "static/infrastructure-51ecb173033cf496b78792fb8e25db6c.svg";